import React, { useEffect, useState } from "react";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import Page from "../../organisms/Page";
import {
  ItemListadoMascotas,
  listarMascotas,
} from "../../../services/mascotasServicios";
import TableSection from "./TableSection";

const breadCrumbs: BreadCrumbItem[] = [
  {
    path: "/",
    label: "Inicio",
  },
  {
    path: "/mascotas",
    label: "Mascotas",
    isActive: true,
  },
];

function ListaMascotas() {
  const [mascotas, setMascotas] = useState([] as ItemListadoMascotas[]);

  useEffect(() => {
    async function poblarMascotas() {
      const resp = await listarMascotas();
      if (resp) {
        setMascotas(resp);
      }
    }

    poblarMascotas();
  }, []);

  return (
    <Page
      description="Visualiza, edita y crea mascotas"
      title="Mascotas"
      breadCrumbs={breadCrumbs}
    >
      <TableSection mascotas={mascotas} />
    </Page>
  );
}

export default ListaMascotas;
